<section class="where-to-buy">
      <div fxLayout="row" fxLayoutAlign="center start">
         <div fxFlex="98%" fxFlex.gt-md="92%">
            <div fxLayout="row" fxLayoutAlign="center start">
               <div class="pageTitle">
                  <h4>Where to Buy</h4>
               </div>
             </div>
             <div fxLayout="row" style="padding: 0 30px;">
               <div fxFlex="100%">
                  <h3>Cheeses are available:</h3>
                  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutAlignGap.gt-md="60px">
                     <address fxFlex.lt-lg="100" fxFlex="calc(50 - 60px)">
                        <h5>Missouri</h5>
                        <div class="StoreLocation">
                           <div class="StoreEl">
                              <h6>St. Louis</h6>
                              <ul>
                                 <li><a href="">Parker's Tabel at Oakland and Yale</a></li>
                                 <li><a href="">Local Harvest</a></li>
                              </ul>
                           </div>
                           <div class="StoreEl">
                              <h6>Kansas City</h6>
                              <ul>
                                 <li><a href="">The Better Cheddar</a></li>
                                 <li><a href="">The Pairing Wine Bar & Grocer*</a></li>
                                 <li><a href="">Cellar Rat*</a></li>
                              </ul>
                           </div>
                           <div class="StoreEl">
                              <h6>Springfield</h6>
                              <ul>
                                 <li><a href="">Brown Derby International Wine Center</a></li>
                                 <li><a href="">The Little Farm Store</a></li>
                                 <li><a href="">Culture Counter*</a></li>
                                 <li><a href="">Mamma Jean's Market (Sunshine and Republic Rd)</a></li>
                                 <li><a href="">Schuchmann Meat</a></li>
                              </ul>
                           </div>
                           <div class="StoreEl">
                              <h6>Ava</h6>
                              <ul>
                                 <li><a href="">Jean's Healthway</a></li>
                                 <li><a href="">Bread of Life</a></li>
                              </ul>
                           </div>
                           <div class="StoreEl">
                              <h6>Bradleyville</h6>
                              <ul>
                                 <li><a href="">Turtle Gulch Gardens</a></li>
                              </ul>
                           </div>
                           <div class="StoreEl">
                              <h6>Branson</h6>
                              <ul>
                                 <li><a href="">Branson Cheese Company</a></li>
                              </ul>
                           </div>
                           <div class="StoreEl">
                              <h6>Camdenton</h6>
                              <ul>
                                 <li><a href="">Fireridge Farmstand</a></li>
                              </ul>
                           </div>
                           <div class="StoreEl">
                              <h6>Chesterfield</h6>
                              <ul>
                                 <li><a href="">Smokehouse Market</a></li>
                              </ul>
                           </div>
                           <div class="StoreEl">
                              <h6>Clinton</h6>
                              <ul>
                                 <li><a href="">Powell Meat Company</a></li>
                              </ul>
                           </div>
                           <div class="StoreEl">
                              <h6>Conway</h6>
                              <ul>
                                 <li><a href="">JD's Milk Eggs and More Dairy Store</a></li>
                              </ul>
                           </div>
                           <div class="StoreEl">
                              <h6>Fordland (Olga)</h6>
                              <ul>
                                 <li><a href="">Kindall Store</a></li>
                              </ul>
                           </div>
                           <div class="StoreEl">
                              <h6>Houston</h6>
                              <ul>
                                 <li><a href="">the health food store</a></li>
                              </ul>
                           </div>
                           <div class="StoreEl">
                              <h6>Jackson</h6>
                              <ul>
                                 <li><a href="">Red Barn Mercantile</a></li>
                              </ul>
                           </div>
                           <div class="StoreEl">
                              <h6>Joplin</h6>
                              <ul>
                                 <li><a href="">Evan's Family Market</a></li>
                              </ul>
                           </div>
                        </div>
                     </address>
                     <address fxFlex.lt-lg="100" fxFlex="calc(50 - 60px)">
                        <h5>Arkansas</h5>
                        <div class="StoreLocation">
                           <div class="StoreEl">
                              <h6>Bentonville</h6>
                              <ul>
                                 <li><a href="https://www.coniferbentonville.com/farm-stand" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">Conifer Farmstand</a></li>
                              </ul>
                           </div>
                           <div class="StoreEl">
                              <h6>Berryville</h6>
                              <ul>
                                 <li><a href="https://mypvfarm.com/about" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">Pleasant Valley Farm</a></li>
                              </ul>
                           </div>
                           <div class="StoreEl">
                              <h6>Damascus (Bee Branch)</h6>
                              <ul>
                                 <li><a href="https://www.rabbitridgefarm.com/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text"><span style="font-size:17px;" class="wixui-rich-text__text">Rabbit Ri</span>dge Farm</a></li>
                              </ul>
                           </div>
                           <div class="StoreEl">
                              <h6>Cotter</h6>
                              <ul>
                                 <li><a href="https://www.facebook.com/cotterbridgemarket/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">Cotter Bridge Market*</a></li>
                              </ul>
                           </div>
                           <div class="StoreEl">
                              <h6>Fort Smith</h6>
                              <ul>
                                 <li><a href="https://www.facebook.com/p/Amazing-Graze-Fort-Smith-100063639458855/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">Amazing Graze *</a></li>
                              </ul>
                           </div>
                           <div class="StoreEl">
                              <h6>Little Rock</h6>
                              <ul>
                                 <li><a href="https://www.hillstationhillcrest.com/ham/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">HAM Market*</a></li>
                                 <li>
                                    <a href="https://www.heightscornermarket.com/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">Heights Corner Market*</a>
                                 </li>
                                 <li>
                                    <a href="https://strattons-market-at-dugans-pub.square.site/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">Stranton's Market Wine &amp; Spirits*</a>
                                 </li>
                                 <li>
                                    <a href="https://www.facebook.com/faremarketlr/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">Fare Market*</a>
                                 </li>
                              </ul>
                           </div>
                           <div class="StoreEl">
                              <h6>Morrilton</h6>
                              <ul>
                                 <li><a href="https://www.facebook.com/McNealPremiumBeef/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">McNeal Premium Beef</a></li>
                              </ul>
                           </div>
                           <div class="StoreEl">
                              <h6>Mountain Home</h6>
                              <ul>
                                 <li>
                                    <a href="https://www.mountainhomeberryfarm.com/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">Mountain Home Berry Farm</a>
                                 </li>
                                 <li>
                                    <a href="https://www.mountainhomeberryfarm.com/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">Mountain Home Berry Farm</a> 
                                 </li>
                                 <li>
                                    <a href="https://meatshopmh.com/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">Meat Shop</a>
                                 </li>
                                 <li>
                                    <a href="https://www.facebook.com/arkansasmountainhomemade/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">Mountain Homemade</a>
                                 </li>
                              </ul>
                           </div>
                           <div class="StoreEl">
                              <h6>Searcy</h6>
                              <ul>
                                 <li>
                                    <a href="https://searcynaturalfoodstore.com/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">Natural Food Store</a>
                                 </li>
                              </ul>
                           </div>
                           <div class="StoreEl">
                              <h5>Oklahoma</h5>
                              <h6>Tulsa</h6>
                              <ul>
                                 <li>
                                    <a href="https://www.lambruscoz.com/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">Lambrusco'z Deli to Go</a>
                                 </li>
                                 <li>
                                    <a href="https://themeatandcheeseshow.com/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">The Meat and Cheese Show *</a>
                                 </li>
                                 <li>
                                    <a href="https://siegis.com/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">Sigi's Sausage Factory</a>
                                 </li>
                              </ul>
                           </div>
                           <div class="StoreEl">
                              <h6>Oklahoma City</h6>
                              <ul>
                                 <li>
                                    <a href="https://www.urbanagrarian.com/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">Urban Agrarian</a>
                                 </li>
                              </ul>
                           </div>
                           <div class="StoreEl">
                              <h6>Edmond</h6>
                              <ul>
                                 <li>
                                    <a href="https://www.urbanagrarian.com/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">Urban Agrarian</a>
                                 </li>
                              </ul>
                           </div>
                           <div class="StoreEl">
                              <h6>Norman</h6>
                              <ul>
                                 <li>
                                    <a href="https://forwardfoods.com/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">Forward Foods</a>
                                 </li>
                              </ul>
                           </div>
                           <div class="StoreEl">
                              <h6>Quapaw</h6>
                              <ul>
                                 <li>
                                    <a href="https://www.quapawtribe.com/606/Farmers-Market-Food-Hub" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">Quapaw Mercantile</a>
                                 </li>
                              </ul>
                           </div>
                        </div>
                        
                        <h5>Kansas</h5>
                        <div class="StoreLocation">
                           <div class="StoreEl">
                              <h6>Kansas City Kansas</h6>
                              <ul>
                                 <li><a href="https://frenchmarketkc.com/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">French Market*</a></li>
                                 <li><a href="http://www.thebettercheddar.com/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">The Better Cheddar</a></li>
                              </ul>
                           </div>
                           <div class="StoreEl">
                              <h6>McCune</h6>
                              <ul>
                                 <li><a href="https://www.facebook.com/mccunemarket/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">McCune Farms to Market by Shenker Farms</a></li>
                              </ul>
                           </div>

                           <div class="StoreEl">
                              <h6>Pittsburg</h6>
                              <ul>
                                 <li><a href="https://meatshedks.square.site/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">The Meat Shed</a></li>
                              </ul>
                           </div>

                           <div class="StoreEl">
                              <h6>Levensworth</h6>
                              <ul>
                                 <li><a href="https://www.jetproduceandmeats.com/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">JET Produce and Meats</a></li>
                              </ul>
                           </div>

                           <div class="StoreEl">
                              <h5>Nebraska</h5>
                              <h6>Papillion</h6>
                              <ul>
                                 <li><a href="https://thenorthwoodscheesehaus.com/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">Northwoods Cheese Haus</a></li>
                              </ul>
                           </div>

                           <div class="StoreEl">
                              <h5>Texas</h5>
                              <h6>Dallas</h6>
                              <ul>
                                 <li><a href="https://www.scardellocheese.com/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">Scardello Cheese</a></li>
                              </ul>
                           </div>
                           <div class="StoreEl">
                              <h6>Fort Worth</h6>
                              <ul>
                                 <li><a href="https://theartofgrazingfw.com/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">Art of Grazing</a></li>
                              </ul>
                           </div>

                           <div class="StoreEl">
                              <h6>Houston</h6>
                              <ul>
                                 <li><a href="https://www.montrosecheeseandwine.com/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">Montross Cheese and Wine</a></li>
                              </ul>
                           </div>

                           <div class="StoreEl">
                              <h6>Spring</h6>
                              <ul>
                                 <li><a href="https://www.hawaiicheese.com/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">Big Island Little Cheese Shop</a></li>
                              </ul>
                           </div>

                           <div class="StoreEl">
                              <h5>Tennessee</h5>
                              <h6>Memphis</h6>
                              <ul>
                                 <li><span style="text-decoration:underline;" class="wixui-rich-text__text">Busters Butcher</span></li>
                                 <li>
                                    <span style="text-decoration:underline;" class="wixui-rich-text__text"><a href="https://cordeliasmarket.com/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">Cordelia's Market*</a></span>
                                 </li>
                              </ul>
                           </div>
                           <div class="StoreEl">
                              <h5>Mississippi</h5>
                              <h6>Tupelo</h6>
                              <ul>
                                 <li><a href="https://wholefamilynutritionandmarket.com/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">Whole Family Nutition</a></li>
                              </ul>
                           </div>
                           <div class="StoreEl">
                              <h5>Alabama</h5>
                              <h6>Birmingham</h6>
                              <ul>
                                 <li><a href="https://thesonofabutcher.com/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">Son of a Butcher</a></li>
                              </ul>
                           </div>

                           <div class="StoreEl">
                              <h5>Lousiana</h5>
                              <h6>New Orleans</h6>
                              <ul>
                                 <li><a href="https://thesonofabutcher.com/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">Son of a Butcher</a></li>
                              </ul>
                           </div>

                           <div class="StoreEl">
                              <h5>Hawaii</h5>
                              <h6>O'ahu and Hawai'i (Big Island)</h6>
                              <ul>
                                 <li><a href="https://www.nakedcowdairyhawaii.com/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">Naked Cow Dairy</a></li>
                              </ul>
                           </div>

                           <div class="StoreEl">
                              <h6>Hawi</h6>
                              <ul>
                                 <li><a href="https://www.hawaiicheese.com/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">Big Island Little Cheese</a></li>
                              </ul>
                           </div>
                           <div class="StoreEl">
                              <h5>South Dakota</h5>
                              <h6>Sioux Falls</h6>
                              <ul>
                                 <li><a href="https://www.looksmarket.com/" target="_blank" rel="noreferrer noopener" class="wixui-rich-text__text">Looks Marketplace&nbsp;</a></li>
                              </ul>
                           </div>

                           <div class="StoreEl">
                              <h5>Ships Nationally</h5>
                              <h6>South Dakota</h6>
                              <ul>
                                 <li><span style="text-decoration:underline;" class="wixui-rich-text__text">Raclette Corner</span></li>
                              </ul>
                           </div>


                        </div>

                     </address>
                  </div>
               </div>
             </div>
             <div fxLayout="row" fxLayoutGap="30px" fxLayoutAlign="space-evenly center">
               <div>
                  <button class="btnDefault">For Our Market Schedule Click Here</button>
               </div>
               <div>
                  <a class="btnDefault" href="https://www.facebook.com/grisondairy" target="_blank">For More Pictures Like us on Facebook!</a>
               </div>
            </div>
         </div>
      </div>
   </section>